import { Injectable } from '@angular/core';
import { FlowModeState } from '../../../../shared/models/state/Flow';
import { FlowMetaData } from '../../../../shared/models/flow-meta-data';


@Injectable({
  providedIn: 'root'
})
export class StateService {

  private flowMode: FlowModeState;
  private flowMetaData: FlowMetaData;
  constructor() {}

  setFlowMode(mode: FlowModeState) {
    this.flowMode = mode;
  }

  getFlowMode(): FlowModeState {
    return this.flowMode;
  }

  setFlowMetaData(metaData: FlowMetaData) {
    this.flowMetaData = metaData;
  }

  getFlowMetaData(): FlowMetaData {
    return this.flowMetaData;
  }
}
